import { connect } from 'react-redux';
import ClientFormWrapper from "../components/general/ClientFormWrapper";
import { ADD_CLIENT, UPDATE_CLIENT } from "../store/actions/client";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ADD_CLIENT: body => dispatch(ADD_CLIENT(body)),   
        UPDATE_CLIENT: body => dispatch(UPDATE_CLIENT(body)),  
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientFormWrapper);


// WEBPACK FOOTER //
// ./src/containers/ClientForm.js